





























































































































































































































import {
  defineComponent,
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  watch,
  onUnmounted,
  ref,
} from '@vue/composition-api';
import { UserIcon } from 'tdesign-icons-vue';
import headbar from '@/renderer/views/desktop/headbar/index.vue';
import Advert from '@/renderer/components/common/Advert.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import user, { User } from '@/renderer/scripts/utils/user';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import linkInvitationHandler from './compositions/linkInvitationHandler';
export default defineComponent({
  components: {
    UserIcon,
    headbar,
    Advert,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const isLogined = computed(() => store.getters.isLogined);
    const mobileStyle = computed(() => store.getters.isMobile || store.getters.isMobileStyle);
    const { coStatus, invitationDetail, methods: invitationMethods } = linkInvitationHandler();
    const orgLogoInfo = computed(() => {
      const { orgName, orgLogo, showOrgNameInUI } = invitationDetail;
      return { orgName, orgLogo, showOrgNameInUI };
    });
    const isShowAdvert = computed(() => !isLogined.value || store.getters.editionFlag === 'personal');
    isShowAdvert.value &&
      reporter.report('pay', {
        pay_source_show: 'invitelink_banner',
      });
    watch(isShowAdvert, val => {
      val &&
        reporter.report('pay', {
          pay_source_show: 'invitelink_banner',
        });
    });
    watch(coStatus, value => {
      if (value === 'addSuccess') {
        methods.startCountdown();
      }
    });
    const remainingTime = ref(3);
    let isCountingDown = false;
    let countdownInterval: number | undefined;
    const methods = {
      startCountdown() {
        isCountingDown = true;
        if (countdownInterval) {
          window.clearInterval(countdownInterval); // 清除之前的倒计时
        }
        countdownInterval = window.setInterval(() => {
          if (remainingTime.value > 0) {
            remainingTime.value--;
          } else {
            window.clearInterval(countdownInterval); // 倒计时结束后清除计时器
            countdownInterval = undefined;
            isCountingDown = false; // 设置为非倒计时状态
            methods.enterCofile();
          }
        }, 1000); // 更新间隔为 1 秒
      },
      // 获取当前登录的方式
      getCurrentLoginedType() {
        const { currentLoginedType } = user.getUserInfo();
        return currentLoginedType;
      },
      needRelogin() {
        const loginType = methods.getCurrentLoginedType();
        // 第三方登录时  不允许切换到新企业
        return [
          User.LoginTypeKey.loginWithWecom,
          User.LoginTypeKey.loginWithYufu,
          User.LoginTypeKey.loginWithSSO,
          User.LoginTypeKey.loginWithLDAP,
        ].includes(loginType as User.LoginTypeKey);
      },
      // 点击加入
      clickTojoin() {
        if (isLogined.value) {
          methods.joinImmediately();
        } else {
          methods.joinAfterLogin();
        }
      },
      // 直接加入
      async joinImmediately() {
        if (invitationDetail.type === 'temporary') {
          await invitationMethods.joinTemporary();
        } else if (invitationDetail.type === 'group') {
          await invitationMethods.joinGroup();
        } else {
          if (methods.needRelogin()) {
            tips.error(i18n_t('请使用手机号或微信扫码登录后再尝试加入新企业'));
            return;
          }
          await invitationMethods.joinOrg();
        }
      },
      // 登录完成再加入
      joinAfterLogin() {
        const { code } = vm.$router.currentRoute.params;
        // 是否需要屏蔽更多登录方式入口
        const hideMoreLoginMethods = true;
        // 只有邀请加入企业时 或者临时成员时，登录需要传invite_code
        if (['org', 'temporary'].includes(invitationDetail.type)) {
          user.setInvitationCode(code);
        }
        user.setLoginFunc(User.LoginFuncKey.loginToJoin);
        ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW, User.LoginFuncKey.loginToJoin, hideMoreLoginMethods);
      },
      // 登录完成动作,loginFrom = ''(代表用户主动点击登录按钮) | 'loginToJoin'(代表用户点击立即加入触发的登录)
      async logined(loginFrom = '') {
        try {
          // 登录成功后清除状态
          user.setInvitationCode('');
          user.setLoginFunc('');

          // 已知这个邀请码已经不可用，不作任何动作
          if (
            ['differentOrgForbidden', 'userLimitReached', 'InvitationGroupNotFound', 'invitationDisabled'].includes(
              coStatus.value,
            )
          )
            return;
          if (invitationDetail.isExpired) return;

          // 先查询当前用户是否已在群组里
          await invitationMethods.getInvitation();
          if (
            [
              'differentOrgForbidden',
              'userLimitReached',
              'InvitationGroupNotFound',
              'invitationDisabled',
              'alreadyInGroup',
              'alreadyTemporary',
            ].includes(coStatus.value)
          ) {
            if (coStatus.value === 'alreadyInGroup' || coStatus.value === 'alreadyTemporary') {
              // 如果登录成功已经加入，这里为了UI上的区别，改成加入成功的UI
              coStatus.value = 'addSuccess';
            }
            return;
          }
          // 主动点击右上角操作，不要自动加入群组
          if (!loginFrom) return;
          // 直接加入
          invitationDetail.type === 'group' && methods.joinImmediately();
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      // 进入网盘
      enterCofile() {
        if (!store.getters.isLogined) {
          tips.info(i18n_t('请先完成登录'));
          return;
        }
        // 被邀请进入新企业时且当前登录态不在该企业时，需要进入新企业 || 临时用户同理
        if (['org', 'temporary'].includes(invitationDetail.type) && invitationDetail.orgId !== store.getters.orgId) {
          invitationMethods.loginToNewOrg();
        } else {
          // 直接进入网盘
          const routerName =
            // eslint-disable-next-line no-nested-ternary
            invitationDetail.type === 'group'
              ? 'collaborationSpace'
              : store.getters.isMobileStyle
              ? 'recentUse'
              : 'workbench';
          dispatchRouter({
            name: routerName,
          });
        }
      },
      async init() {
        await invitationMethods.getInvitation();
        // 协作群组邀请曝光上报
        if (invitationDetail.type === 'group') {
          reporter.report('group_join', {
            group_name: invitationDetail.groupName,
          });
        }
        // 微信登录后ipc监听不到，使用sessionStorage里的数据来判断
        const { loginType, loginFunc } = user.getUserInfo();
        if (
          [User.LoginTypeKey.loginWithWechat, User.LoginTypeKey.loginWithWecom].includes(loginType as User.LoginTypeKey)
        ) {
          if (!loginFunc) return;
          setTimeout(() => {
            methods.logined(loginFunc as string);
            // 用完立即删除
            user.setLoginFunc('');
          }, 500);
        }
      },
    };
    methods.init();
    watch(
      () => store.getters.orgId,
      val => {
        invitationMethods.getInvitation();
      },
    );

    watch(
      () => store.getters.isLogined,
      val => {
        invitationMethods.getInvitation();
      },
    );

    ipc.on(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_LOGINED, methods.logined);
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_LOGINED, methods.logined);
      if (countdownInterval) {
        window.clearInterval(countdownInterval);
      }
    });
    return {
      mobileStyle,
      coStatus,
      invitationDetail,
      orgLogoInfo,
      ...methods,
      isShowAdvert,
      remainingTime,
    };
  },
});
